import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { PageType } from '../dto/types';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/service/auth.service';
import { TermsAndConditionsService } from './service/terms-and-conditions.service';
import {
  WEBSITE_PROD_ORCA_PRIVACY_POLICY,
  WEBSITE_PROD_ORCA_TERMS_OF_USE,
} from '../../../../../environments/urlService';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss',
    '../entrance-group.scss'],
})
export class TermsAndConditionsComponent implements OnDestroy {
  @Output() newPageEvent = new EventEmitter<PageType>();
  isUserAgreed = false;
  private _destroyStream: Subject<void> = new Subject<void>();

  constructor(private routerService: Router,
    private authService: AuthService,
    private termsAndConditionService: TermsAndConditionsService) {
  }

  ngOnDestroy(): void {
    localStorage.removeItem('termsAndConditions');
    this._destroyStream.next();
  }


  toggleIsUserAgreed(): void {
    this.isUserAgreed = !this.isUserAgreed;
  }

  submit(): void {
    this.termsAndConditionService.setAgreement().subscribe({
      next: () => {
        this.routerService.navigateByUrl('/entrance');
      },
      error: () => this.changePage('login'),
      complete: () => localStorage.removeItem('termsAndConditions'),
    });
  }

  changePage(page: PageType): void {
    this.newPageEvent.emit(page);
  }

  redirectTerms(): void {
    window.open(WEBSITE_PROD_ORCA_TERMS_OF_USE, '_blank');
  }

  redirectPolicy(): void {
    window.open(WEBSITE_PROD_ORCA_PRIVACY_POLICY, '_blank');
  }
}
